import React from 'react';
import {Field} from 'react-final-form';
import {Input, Label} from 'reactstrap';
import FieldError from './FieldError';
import {required} from '../helpers/Validators';
import NumberFormat from 'react-number-format';
import {withTranslation} from 'react-i18next';

class TextField extends React.Component{
  render() {
    const {item, t} = this.props;
    return (
      <Field name={item.name} validate={item.required ? required : null} initialValue={item.value}>
        {({input}) => (
          <div>
            <Label className="form-group has-float-label mb-2">
              <div>
                <span>
                  {item.i18n}
                  {typeof item.valid === 'boolean' &&
                    <span className={item.valid ? 'text-success' : 'text-danger'}>
                      {item.valid ? ` (${t('confirmed')})` : ` (${t('not confirmed')})`}
                    </span>
                  }
                </span>
                <span>{item.unit}</span>
                {item.required ? <span className="required">*</span> : ''}
              </div>
              {!item.format ?
                <Input
                  {...item}
                  {...input}
                  className={item.customClass}
                />
                :
                <NumberFormat
                  {...input}
                  onChange={() => {}}
                  displayType={'input'}
                  mask=" "
                  format={item.format}
                  placeholder={item.placeholder ? item.placeholder : null}
                  value={input.value}
                  onValueChange={(values) => {
                    const {value} = values;
                    input.onChange(value);
                  }}
                  customInput={Input}
                  style={{direction: 'ltr'}}
                />
              }
              <FieldError name={item.name}/>
            </Label>
          </div>
        )}
      </Field>
    );
  }
}

export default withTranslation()(TextField);
